// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._13lsf1ug>*{flex-basis:0%}\n._19pku2gc{margin-top:var(--ds-space-100,8px)}\n._1bah1yb4{justify-content:space-between}\n._1e0c1txw{display:flex}\n._1o0a1h6o>*>button{justify-content:center}\n._nbgx1epz>span{width:var(--ds-space-1000,5pc)}\n._otyr1ejb{margin-bottom:var(--ds-space-300,24px)}\n._pof3u2gc>*+*{margin-left:var(--ds-space-100,8px)}\n._v5ynkb7n>*{flex-shrink:1}\n._zdxokb7n>*{flex-grow:1}", ""]);
// Exports
module.exports = exports;
